import { FC, useEffect, useRef, useState } from "react";
import ScrollableContent from "./ScrollableContents";
import { UpgradeBanner } from "./upgrade/UpgradeBanner";
import { useShowBannerAd } from "./hooks/adHooks";

const ScrollableContentWithAds: FC = ({ children }) => {
    const [bottomOffset, setBottomOffset] = useState<number>(0);

    const showBannerAd = useShowBannerAd();

    const bannerEl = useRef<HTMLDivElement | null>(null);

    const recalculateBottomOffset = () => {
        const adHeight = bannerEl.current?.getBoundingClientRect().height;
        const offset = adHeight ? adHeight + 5 : 0;
        setBottomOffset((current) => (current === offset ? current : offset));
    };

    useEffect(() => {
        recalculateBottomOffset();

        // The banner settles after this effect has run — it swaps in its own copy and can
        // reflow — and the offset it feeds into ScrollableContent decides where the scroller
        // ends, so measuring it once leaves the last rows of the page unreachable. Same
        // reasoning as the re-measurement in ScrollableContents.
        const remeasure = () =>
            window.requestAnimationFrame(recalculateBottomOffset);
        const resizeObserver =
            typeof ResizeObserver === "undefined"
                ? null
                : new ResizeObserver(remeasure);
        if (bannerEl.current) {
            resizeObserver?.observe(bannerEl.current);
        }

        return () => {
            resizeObserver?.disconnect();
        };
    }, [children, showBannerAd]);

    return (
        <>
            <ScrollableContent bottomOffset={showBannerAd ? bottomOffset : 0}>
                {children}
            </ScrollableContent>
            <div ref={bannerEl}>
                <UpgradeBanner />
            </div>
        </>
    );
};

export default ScrollableContentWithAds;
